module.exports = __webpack_public_path__ + "static/img/yunnan01.22dac83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/travel/yunnan01.png
// module id = sM04
// module chunks = 1